import { FEATURES, MODAL, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/valuation',
    name: 'valuation',
    redirect: '/valuation/geral',
    meta: {
      can_show: FEATURES.ESTRATEGIA,
      search: {
        title: 'Estratégia',
        description: 'Estratégia, performance e partnership do escritório',
        keywords: [
          'estratégia',
          'valuation',
          'performance',
          'partnership',
          'indicadores',
        ],
        icon: 'chart-grow',
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () => lazyLoadView(import('@views/dashboard-indicadores/index')),
    children: [
      {
        path: 'geral',
        name: 'valuation.visao_geral',
        meta: {
          can_show: 'biGeral',
          search: {
            title: 'Estratégia — Visão Geral',
            description: 'Visão geral de estratégia e performance',
            keywords: ['estratégia', 'visão geral', 'performance', 'resumo'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/partnership/views/view-partnership-overview')
          ),
        children: [
          {
            path: ':id_profissional',
            name: 'valuation.visao_geral.profissional',
            meta: {
              can_show: 'biGeral',
            },
            component: () =>
              lazyLoadView(
                import('@modules/partnership/views/view-partnership-overview')
              ),
          },
        ],
      },
      {
        path: 'comite-resultados',
        name: 'valuation.comite_resultados',
        meta: {
          can_show: FEATURES.COMITE_RESULTADOS,
          permission: ['gestor'],
          search: {
            title: 'Estratégia — Comitê de Resultados',
            description: 'Acompanhamento do comitê de resultados',
            keywords: ['comitê', 'resultados', 'estratégia', 'performance'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/partnership/views/view-comite-resultados')
          ),
      },
      {
        path: 'partnership',
        name: 'valuation.partnership',
        meta: {
          can_show: 'biPartnership',
          search: {
            title: 'Estratégia — Partnership',
            description: 'Indicadores de partnership e sociedade',
            keywords: ['partnership', 'sociedade', 'estratégia', 'sócios'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@modules/partnership/views/view-partnership')),
      },

      /* {
        path: 'modelos',
        name: 'partnership.templates',
        meta: {
          can_show: FEATURES.DOCS,
        },
        component: () =>
          lazyLoadView(
            import('@src/modules/documents/views/documents-templates')
          ),
      }, */

      {
        path: 'carreira',
        name: 'valuation.carreira',
        meta: {
          can_show: 'biCarreira',
          search: {
            title: 'Estratégia — Plano de Carreira',
            description: 'Plano de carreira e evolução dos profissionais',
            keywords: [
              'carreira',
              'plano de carreira',
              'estratégia',
              'evolução',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@views/dashboard-indicadores/carreira')),
      },
      {
        path: 'individual',
        name: 'valuation.visao_geral.individual',
        meta: {
          can_show: 'biIndividual',
          search: {
            title: 'Estratégia — Individual',
            description: 'Visão individual de performance do profissional',
            keywords: [
              'individual',
              'profissional',
              'estratégia',
              'performance',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/partnership/views/view-partnership-overview')
          ),
        children: [
          {
            path: ':id_profissional',
            name: 'valuation.visao_geral.individual.especifico',
            meta: {
              can_show: 'biIndividual',
            },
            component: () =>
              lazyLoadView(
                import('@modules/partnership/views/view-partnership-overview')
              ),
          },
        ],
      },
      {
        path: 'configuracoes',
        name: 'valuation.configuracoes',
        meta: {
          can_show: 'biSettings',
          permission: ['gestor'],
          search: {
            title: 'Estratégia — Configurações',
            description: 'Configurações do módulo de estratégia',
            keywords: ['configurações', 'estratégia', 'ajustes', 'settings'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@views/dashboard-indicadores/configuracoes-partners')
          ),
      },
      {
        path: 'profissionais',
        name: 'valuation.professionals',
        meta: {
          can_show: 'biProfissionais',
          search: {
            title: 'Estratégia — Profissionais',
            description: 'Indicadores de estratégia por profissional',
            keywords: [
              'profissionais',
              'assessores',
              'estratégia',
              'performance',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@views/dashboard-indicadores/bi-professionals')),
      },
      {
        path: 'planilhas',
        name: 'valuation.planilhas',
        meta: {
          can_show: 'biPlanilhas',
          search: {
            title: 'Estratégia — Importações',
            description: 'Importações e planilhas de estratégia',
            keywords: ['importações', 'planilhas', 'estratégia', 'upload'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(import('@views/dashboard-indicadores/planilhas-bi')),
      },
      {
        path: 'importar',
        name: 'valuation.planilhas.importar',
        meta: {
          can_show: 'biPlanilhas',
          search: {
            title: 'Estratégia — Importar Planilha',
            description: 'Importar planilha de dados de estratégia',
            keywords: ['importar', 'planilha', 'estratégia', 'upload'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@views/dashboard-indicadores/view-importar-planilha')
          ),
      },
      {
        path: 'clientes',
        name: 'valuation.customers',
        meta: {
          permission: ['gestor'],
          search: {
            title: 'Estratégia — Clientes',
            description: 'Base de clientes na visão de estratégia',
            keywords: ['clientes', 'estratégia', 'carteira', 'base'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/partnership/views/customer/view-customers')
          ),
      },
      {
        path: 'data_room',
        name: 'valuation.bi_data_room',
        meta: {
          can_show: FEATURES.PARTNERSHIP_DATA_ROOM,
          permission: ['gestor'],
          search: {
            title: 'Estratégia — Data Room',
            description: 'Data room na visão de estratégia',
            keywords: ['data room', 'documentos', 'estratégia', 'arquivos'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
            actions: [
              {
                id: 'enviar-arquivo-data-room',
                title: 'Enviar arquivo',
                keywords: [
                  'cadastrar arquivo',
                  'novo arquivo',
                  'upload',
                  'data room',
                ],
                to: { name: 'valuation.bi_data_room' },
                modal: MODAL.BI_SAVE_DATA_ROOM_FILE,
              },
              {
                id: 'nova-campanha-data-room',
                title: 'Nova campanha',
                keywords: [
                  'criar campanha',
                  'campanha de coleta',
                  'captação',
                  'data room',
                ],
                to: { name: 'valuation.bi_data_room' },
                modal: MODAL.MODAL_CREATE_CAMPAIGN,
              },
            ],
          },
        },
        component: () =>
          lazyLoadView(import('@modules/partnership/views/view-data-room')),
      },

      {
        path: 'calculadora',
        name: 'valuation.calculator',
        meta: {
          internal: true,
          search: {
            title: 'Estratégia — Calculadora',
            description: 'Calculadora de valuation e cenários',
            keywords: ['calculadora', 'valuation', 'estratégia', 'cenários'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/partnership/views/calculator/view-calculator')
          ),
      },

      {
        path: 'ranking',
        name: 'valuation.ranking',
        meta: {
          can_show: FEATURES.PARTNERSHIP_RANKING_CAPTACAO,
          search: {
            title: 'Estratégia — Ranking',
            description: 'Ranking de captação dos profissionais',
            keywords: ['ranking', 'captação', 'estratégia', 'profissionais'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/partnership/views/view-ranking/ranking-captacao.vue'
            )
          ),
      },
    ],
  },
]
